import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Addproduct from './02AddProduct';
import UpdateProduct from './03UpdateProduct';
import RemoveProduct from "./04RemoveProduct"
import Grid from '@mui/material/Grid';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container direction="column" justifyContent="flex-start" alignItems="center" style={{ width: "100%", height: "100%" }}>
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Add Product" {...a11yProps(0)} />
          <Tab label="Update Product" {...a11yProps(1)} />
          <Tab label="Delete Product" {...a11yProps(2)} />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Addproduct></Addproduct>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <UpdateProduct/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <RemoveProduct></RemoveProduct>
      </TabPanel>
    </Box>
    </Grid>
  );
}
